import { useEffect, useState } from "react";
import { Trans } from "@lingui/react/macro";
import { initClarity } from "@/lib/clarity";
import { getConsentStatus, setConsentStatus } from "@/lib/cookieConsent";
import { initPinterest } from "@/lib/pinterest";
import { initSentry } from "@/lib/sentry";

export default function CookieBanner() {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(
    () => getConsentStatus() === "undecided",
  );

  useEffect(() => {
    const frameId = window.requestAnimationFrame(() => {
      setMounted(true);
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, []);

  if (!mounted || !visible) {
    return null;
  }

  const handleAccept = () => {
    setVisible(false);
    setConsentStatus("accepted");
    initSentry();
    initClarity();
    initPinterest();
  };

  const handleReject = () => {
    setVisible(false);
    setConsentStatus("rejected");
  };

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-[var(--color-border)] bg-white p-4 sm:px-6"
      data-testid="cookie-banner"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center gap-3 sm:flex-row sm:gap-4">
        <p className="flex-1 text-center text-sm text-[var(--color-muted)] sm:text-left">
          <Trans>
            Usamos cookies para mejorar tu experiencia y analizar errores.
            Puedes aceptar o rechazar las cookies no esenciales.
          </Trans>
        </p>
        <div className="flex shrink-0 gap-3">
          <button
            className="app-btn-secondary px-4 py-2 text-sm"
            data-testid="cookie-reject"
            onClick={handleReject}
            type="button"
          >
            <Trans>Rechazar</Trans>
          </button>
          <button
            className="app-btn-primary px-4 py-2 text-sm"
            data-testid="cookie-accept"
            onClick={handleAccept}
            type="button"
          >
            <Trans>Aceptar</Trans>
          </button>
        </div>
      </div>
    </div>
  );
}
